import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

import { EntitySummaryBlock } from '@core/services/ai/ai-assistant.service';

@Component({
  selector: 'app-ai-entity-summary-block',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  template: `
    <div class="card">
      <header class="card__header">
        <mat-icon class="card__icon">{{ block.icon || 'info' }}</mat-icon>
        <span class="card__title">{{ block.title }}</span>
      </header>
      <dl class="card__fields">
        @for (f of block.fields; track f.label) {
          <div class="card__field" [class.card__field--emphasis]="f.emphasis">
            <dt>{{ f.label }}</dt>
            <dd>{{ f.value }}</dd>
          </div>
        }
      </dl>
      @if (block.caption) {
        <p class="card__caption">{{ block.caption }}</p>
      }
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .card {
        background: #fff;
        border: 1px solid rgba(15, 23, 42, 0.08);
        border-radius: 12px;
        padding: 12px 14px;
      }
      .card__header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
      }
      .card__icon {
        font-size: 20px;
        width: 20px;
        height: 20px;
        color: #6366f1;
      }
      .card__title {
        font-weight: 600;
        font-size: 14px;
        color: rgba(15, 23, 42, 0.92);
      }
      .card__fields {
        margin: 0;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
        gap: 8px 16px;
      }
      .card__field {
        display: flex;
        flex-direction: column;
        gap: 2px;
        min-width: 0;
      }
      .card__field dt {
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: rgba(15, 23, 42, 0.5);
      }
      .card__field dd {
        margin: 0;
        font-size: 14px;
        color: rgba(15, 23, 42, 0.85);
        overflow-wrap: anywhere;
        word-break: break-word;
      }
      .card__field--emphasis dd {
        font-weight: 700;
        font-size: 16px;
        color: rgba(15, 23, 42, 0.95);
      }
      .card__caption {
        margin: 10px 0 0;
        font-size: 12px;
        color: rgba(15, 23, 42, 0.55);
        font-style: italic;
      }
    `
  ]
})
export class AiEntitySummaryBlockComponent {
  @Input({ required: true }) block!: EntitySummaryBlock;
}
